import React from "react";
import Layout from "../components/Layout";
import { ExternalLeadInboxCard } from "../components/ExternalLeadInboxCard";
import { useScrollRestore } from "../hooks/useScrollRestore";

export default function LeadInboxPage() {
  useScrollRestore();
  return (
    <Layout>
      <div className="p-4 md:p-8 max-w-6xl mx-auto space-y-6" data-testid="lead-inbox-page">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-slate-900 font-['Manrope']">External Lead Inbox</h1>
          <p className="text-sm text-slate-500 mt-1">
            Leads captured from external channels in the last 24 hours that still need first contact.
            A lead drops off automatically the moment you log any interaction or move it off the "new" stage.
          </p>
        </div>
        <ExternalLeadInboxCard compact={false} maxRows={50} />
      </div>
    </Layout>
  );
}
